import { Patient } from "~/common/utils";
import {
  UpdatePatientDetailsRequest,
  UpdatePatientPhoneNumberRequestPayload,
} from "~/providers/types/patients";
import { api, PaginatedServiceResponse } from "./axios";

export const getPatients = async (params?: URLSearchParams) => {
  const res = await api.get<PaginatedServiceResponse<Patient[]>>(
    "/v1/team-members/patients",
    {
      params,
      paramsSerializer: {
        indexes: null,
      },
    },
  );
  return res.data;
};

export const updatePatientInfo = async ({
  patient_id,
  ...payload
}: UpdatePatientDetailsRequest) => {
  const response = await api.put<Patient>(
    `/v1/team-members/patients/${patient_id}`,
    payload,
  );
  return response.data;
};

export const updatePatientPhoneNumber = async ({
  patient_id,
  phone_number,
}: UpdatePatientPhoneNumberRequestPayload) => {
  const { data } = await api.put<string>(
    `/v1/team-members/patients/${patient_id}/phone`,
    {
      phone_number,
    },
  );

  return data;
};
